import React from 'react';
import Navbar from '../components/Navbar';
import './Refund.css';

function Refund() {
    return (
        <div className="page-container refund-page">
            <Navbar />

            <section className="refund-hero">
                <div className="container">
                    <div className="refund-hero-content">
                        <span className="section-badge">ポリシー</span>
                        <h1 className="refund-title">
                            返金 <span className="gradient-text">ポリシー</span>
                        </h1>
                        <p className="refund-subtitle">
                            最終更新日：2026年3月19日
                        </p>
                    </div>
                </div>
            </section>

            <section className="refund-content">
                <div className="container">
                    <div className="refund-wrapper">
                        <div className="refund-section">
                            <h2>返品・返金ポリシー</h2>
                            <p>
                                「クリシュナと話す」をご利用いただきありがとうございます。私たちは、お客様の精神的な成長への取り組みを大切にし、india.talktokrishna.ai で最高のエクスペリエンスを提供できるよう努めています。
                            </p>
                        </div>

                        <div className="refund-section">
                            <h2>非有形の取消不能な商品（「デジタル製品」）</h2>
                            <p>
                                注文が確定し、製品が送信された後は、非有形の取消不能な商品（「デジタル製品」）の返金は行いません。
                            </p>
                            <p>
                                当社の主なサービスは、AIが導く神聖な会話や精神的コンテンツへのアクセスを含んでおり、これらの製品のデジタルな性質上、一度アクセスが許可されると「返品」することはできません。
                            </p>
                        </div>

                        <div className="refund-section">
                            <h2>サポートと支援</h2>
                            <p>
                                サービスの受け取り、チャットへのアクセス、または技術的な問題が発生した場合は、サポートまでご連絡いただくことをお勧めします。
                            </p>
                            <p>
                                当社のチームは、お客様の精神的な旅が中断されることなく、有意義なものとなるよう尽力します。
                            </p>
                        </div>

                        <div className="refund-section">
                            <h2>お問い合わせ</h2>
                            <p>返品・返金ポリシーについてご質問がある場合は、以下までご連絡ください：</p>
                            <ul>
                                <li>メール：<a href="mailto:support@talktokrishna.ai">support@talktokrishna.ai</a></li>
                                <li>ウェブサイト：<a href="/contact">お問い合わせフォーム</a></li>
                            </ul>
                        </div>

                        <div className="refund-footer-note">
                            <p>
                                <strong>神聖なコミットメント：</strong> 購入を進めることにより、お客様は本ポリシーを認め、同意したものとみなされます。
                                「クリシュナと話す」ファミリーの一員になっていただき、心より感謝申し上げます。
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Refund;
